import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconLikeOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconLikeOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-like-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.54163 7.49984C1.54163 4.89937 3.6495 2.7915 6.24996 2.7915C7.735 2.7915 8.97502 3.50454 9.99996 4.75647C11.0249 3.50454 12.2649 2.7915 13.75 2.7915C16.3504 2.7915 18.4583 4.89937 18.4583 7.49984C18.4583 8.38019 18.0902 9.25213 17.5784 10.0668C17.0613 10.8899 16.3518 11.7258 15.5693 12.5481C14.7845 13.3728 13.9043 14.2064 13.0354 15.02C12.9136 15.1339 12.7922 15.2475 12.6712 15.3605C11.923 16.06 11.1932 16.7422 10.5303 17.4052C10.2374 17.6981 9.76252 17.6981 9.46963 17.4052C8.80668 16.7422 8.07691 16.06 7.32867 15.3605C7.20771 15.2475 7.08628 15.1339 6.96456 15.02C6.09564 14.2064 5.21539 13.3728 4.43061 12.5481C3.64812 11.7258 2.93864 10.8899 2.42152 10.0668C1.90976 9.25213 1.54163 8.38019 1.54163 7.49984ZM6.24996 4.2915C4.47792 4.2915 3.04163 5.7278 3.04163 7.49984C3.04163 7.97365 3.24641 8.56004 3.69168 9.26884C4.1316 9.96911 4.76326 10.7218 5.51723 11.5141C6.2689 12.304 7.12042 13.111 7.98979 13.925C8.10971 14.0373 8.23003 14.1498 8.35046 14.2624C8.90816 14.7837 9.46801 15.307 9.99996 15.8228C10.5319 15.307 11.0917 14.7837 11.6495 14.2624C11.7699 14.1498 11.8902 14.0373 12.0101 13.925C12.8795 13.111 13.731 12.304 14.4827 11.5141C15.2367 10.7218 15.8683 9.96911 16.3082 9.26884C16.7535 8.56004 16.9583 7.97365 16.9583 7.49984C16.9583 5.7278 15.522 4.2915 13.75 4.2915C12.6389 4.2915 11.6064 4.9041 10.6339 6.4423C10.4964 6.6597 10.2572 6.7915 9.99996 6.7915C9.74275 6.7915 9.50349 6.6597 9.36603 6.4423C8.3935 4.9041 7.36105 4.2915 6.24996 4.2915Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-like-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-like-off", "wpp-icon-like-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-like-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-like-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconLikeOff$1);
      }
      break;
  } });
}

const WppIconLikeOff = WppIconLikeOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconLikeOff, defineCustomElement };
